import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SeeItems {}

export const seeItems = createAction<ActionType, SeeItems>(
    ActionType.NOTI__EC__SEE_ITEMS,
);
